import React from "react";

/**
 * Mogambo video title — reference markup (first child of .casino-video):
 * .casino-video-title > span.casino-name " " .casino-video-rid
 */
export default function MogamboVideoTitle({ title = "Mogambo", roundId }) {
  return (
    <div className="casino-video-title">
      <span className="casino-name">{title}</span>{" "}
      <div className="casino-video-rid">Round ID: {roundId}</div>
    </div>
  );
}
